/** config-legacy feature constants. */

/**
 * Hosts where the Applicant-tab "DB Backup" section is shown — the Angular
 * production host (`cornerstone.libertyrent.com`) and its v2 (React) equivalent.
 */
export const BACKUP_HOSTS = ['cornerstone.libertyrent.com', 'v2-cornerstone.libertyrent.com']
